export default "__VITE_ASSET__yo6oaHV9__"